import { useActiveWorkspace } from "./useActiveWorkspace";

export function useShowAccountNumbers(): boolean {
    const workspace = useActiveWorkspace();

    return workspace?.showAccountNumbers ?? true;
}
